import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  storeSearchWord: '',
  storeId: '',
  sensorData: {
    id: '',
    name: '',
    currentTemp: 0,
    currentHumid: 0,
  },
  masterKidInputs: {
    name: '',
    code: '',
    tel: '',
  },
  inviteInputs: {
    email: '',
    name: '',
    store: '',
    storeId: '',
  },
  registerInputs: {
    isCheckId: false,
    password: '',
    passwordConfirm: '',
    tel: '',
    serverAuthCode: '',
    localAuthCode: '',
    auth: null,
  },
  usersLoading: [],
  serviceError: false,
};

const serviceSlice = createSlice({
  name: 'service',
  initialState,
  reducers: {
    changeProp: (state, { payload: { key, value } }) => {
      state[key] = value;
    },
    changeSensorData: (state, { payload: { key, value } }) => {
      state.sensorData[key] = value;
    },
    changeMasterKidInputs: (state, { payload: { key, value } }) => {
      state.masterKidInputs[key] = value;
    },
    initializeMasterKidInputs: state => {
      state.masterKidInputs = initialState.masterKidInputs;
    },
    changeInviteInputs: (state, { payload: { key, value } }) => {
      state.inviteInputs[key] = value;
    },
    initializeInviteInputs: state => {
      state.inviteInputs = initialState.inviteInputs;
    },
    changeRegisterInputs: (state, { payload: { key, value } }) => {
      state.registerInputs[key] = value;
    },
    initializeRegisterInputs: state => {
      state.registerInputs = initialState.registerInputs;
    },
    addUsersLoading: (state, { payload }) => {
      state.usersLoading = [...state.usersLoading, payload];
    },
    subtractUsersLoading: (state, { payload }) => {
      state.usersLoading = state.usersLoading.filter(el => el !== payload);
    },
  },
});

export const {
  changeProp,
  changeSensorData,
  changeMasterKidInputs,
  initializeMasterKidInputs,
  changeInviteInputs,
  initializeInviteInputs,
  changeRegisterInputs,
  initializeRegisterInputs,
  addUsersLoading,
  subtractUsersLoading,
} = serviceSlice.actions;

export default serviceSlice.reducer;
